import React from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from '../utils/prop-types';
var FilterListItem = function FilterListItem(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "filter-row ".concat(props.filter.property)
  }, /*#__PURE__*/React.createElement("input", {
    name: props.filter.id,
    type: "checkbox",
    checked: props.filtersState[props.filter.id],
    id: "filterCheckbox-".concat(props.filter.id),
    onChange: function onChange(e) {
      props.onChangeFilter(props.filter, e);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "filterCheckbox-".concat(props.filter.id)
  }, props.filter.label));
};
FilterListItem.propTypes = {
  filter: defaultPropTypes.filter.isRequired,
  onChangeFilter: defaultPropTypes.func.isRequired,
  filtersState: PropTypes.arrayOf(PropTypes.bool).isRequired
};
export default FilterListItem;